const TopNavigation = ({ children }) => {
    return (
        <header className="header">
            <div className="header__actions">
                {children}
            </div>
        </header>
    );
};

export default TopNavigation;
